import { App, defineAsyncComponent } from 'vue';

const components = [
  {
    name: 'Input',
    component: defineAsyncComponent(() => import('@/components/shared/Input.vue')),
  },
  {
    name: 'Select',
    component: defineAsyncComponent(() => import('@/components/shared/Select.vue')),
  },
  {
    name: 'Table',
    component: defineAsyncComponent(() => import('@/components/shared/Table.vue')),
  },
  {
    name: 'Modal',
    component: defineAsyncComponent(() => import('@/components/shared/Modal.vue')),
  },
  {
    name: 'AccordionItem',
    component: defineAsyncComponent(() => import('@/components/shared/AccordionItem.vue')),
  },
  {
    name: 'DatePicker',
    component: defineAsyncComponent(() => import('@/components/shared/DatePicker.vue')),
  },
  {
    name: 'Button',
    component: defineAsyncComponent(() => import('@/components/shared/Button.vue')),
  },
  {
    name: 'LoadingState',
    component: defineAsyncComponent(() => import('@/components/shared/LoadingState.vue')),
  },
];

export default {
  install: function (app: App) {
    components.forEach((component) => {
      const name = `Beva${component.name}`;
      app.component(name, component.component);
    });
  },
};
